"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductPricesByAttributes = void 0;
/**
 * Function search products prices by list of attributes
 * @kind function
 */
const getProductPricesByAttributes = (prices, searchAttributes, orderByAddedAt = false) => {
    const matchedPrices = [];
    if (searchAttributes.length === 0) {
        throw new Error('@merchx/helpers: Function getProductPricesByAttributes - search attributes should be defined!');
    }
    prices.forEach((price) => {
        let allAttributesMatched = true;
        for (const searchAttribute of searchAttributes) {
            const matchedAttribute = price.attributes.find((item) => item.attribute === searchAttribute.attribute && item.value === searchAttribute.value);
            allAttributesMatched = allAttributesMatched && matchedAttribute !== undefined;
        }
        if (allAttributesMatched) {
            matchedPrices.push(price);
        }
    });
    return orderByAddedAt ? matchedPrices.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1)) : matchedPrices;
};
exports.getProductPricesByAttributes = getProductPricesByAttributes;
//# sourceMappingURL=getProductPricesByAttributes.js.map